<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->
<ngx-spinner type="ball-clip-rotate-multiple" bdColor="rgb(0,0,0,0)" color = "#00ff00"></ngx-spinner>
<gm-showcase showcase-title="Accident Person Type Management">
  <div class="showcase-body">
    <div class="margin: auto; max-width: 1000px; margin-bottom: 50px;margin-top: 20px;">
      <span class="section-header">Add New</span>
      <div class="row">
        <div class="col-lg-2 col-md-8 col-sm-8 col-xs-8 group">
          <input id="newType" #newType class="modelo-text-input" type="text" maxlength="20" (blur)="onBlur($event)">
          <label for="newType">Person Type:</label>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-4 group">
          <button id="addNew" class="btn-xs btn-primary btn-group" (click)="addNew(newType.value)"><i
            class="fa fa-save"></i>&nbsp;Submit
          </button>
        </div>
      </div>
      <div>&nbsp;</div>
      <form #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate>
        <table class="bordered-table highlight-table ">
          <thead class="data-table-header">
          <tr>
            <th>Person Type</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let dl of accidentPersonTypes; let index = index; " class="data-table-row">
            <td>
              <input name="{{'type__'+ dl.accidentPersonTypeId}}" class="modelo-text-input" type="text" [(ngModel)]="dl.type" maxlength="20" required #type="ngModel">
              <small *ngIf="type.errors && type.errors.required" class="validationError">Required</small>
            </td>
          </tr>
          </tbody>
        </table>
      </form>
    </div>
  </div>
</gm-showcase>
<div style="z-index:1; position:absolute; margin-left: 80px; margin-top: 6px;">
  <button id="SaveChange" #SaveChange class="btn btn-primary-white btn-group" (click)="f.ngSubmit.emit()" [disabled]="!f.form.valid"><i class="fa fa-save"></i>&nbsp;Save</button>&nbsp;
  <button id="ResetChange" #ResetChange class="btn btn-primary-white btn-group" (click)="resetChanges()">
    <i class="fa fa-refresh"></i>&nbsp;Reset</button>&nbsp;
  <span style="color: White; font-weight: bold;"> {{returnMessage}}</span>
</div>
